<template>
  <layout-breadcrumb-cartao
    cartaoCustom
    titulo="Detalhes da Unimed"
    :breadcrumb="bread"
    icone="settings"
  >
    <div slot="cartao">
      <unicom-linha>
        <unicom-coluna sm="12">
          <CartaoInformacoes
            :loading="loadingInformacoes"
            :quantidadeObservacoes="quantidadeObservacoes"
            :objetoInformacoes="objetoInformacoes"
            @abrir-modal="abrirModalAnalista"
            @adicionar-observacao="adicionarObservacao"
            @mostrar-observacao="mostrarObservacao"
          />
        </unicom-coluna>
        <unicom-coluna sm="12">
          <TabelaContatos
            :listagemContatos="listagemContatos"
            :loadingContatos="loadingContatos"
            :valoresSwitchProp="valoresSwitchProp"
            @adicionar-contato="abrirModalAdicionar"
            @editar-contato="abrirModalEditar"
            @historico="abrirModalHistorico"
            @excluir-contato="excluirContato"
            @editar-notificacao="editarNotificacao"
          />
        </unicom-coluna>
        <unicom-coluna sm="12">
          <TabelaContatosExcluidos
            :listagemContatosExcluidos="listagemContatosExcluidos"
            :loadingContatos="loadingContatosExcluidos"
            @motivo-exclusao="abrirModalMotivoExclusao"
            @historico="abrirModalHistorico"
            @excluir-contato="excluirContato"
            @editar-notificacao="editarNotificacao"
          />
        </unicom-coluna>
        <unicom-coluna sm="12">
          <CartaoData
            v-if="!mostrarCartaoData"
            :objetoDataNotificacaoProp="objetoDataNotificacao"
            :loading="loadingInformacoes"
            @salvar-data="salvarData"
          />
        </unicom-coluna>

        <unicom-coluna sm="12">
          <TipoAtuacaoClassificacao
            v-if="mostrarClassificacao"
            :objetoClassificacaoProp="objetoClassificacao"
            :loading="loadingInformacoes"
            :listaTipoAtuacao="listaTipoAtuacao"
            @abrir-modal-justificativa="abrirModalClassificacaoJustificativa"
            @abrir-modal-historico-classific="abrirModalHistoricoClassific"
          />
        </unicom-coluna>
      </unicom-linha>
      <ModalAcaoAnalista
        v-model="mostrarModalAnalista"
        :tipoAcao="tipoAcaoModalAnalista"
        :idUsuarioUnimedGiu="idUsuarioUnimedGiu"
        :listagemAnalista="listagemAnalista"
        @salvar-modal="salvarModalAnalista"
      />
      <ModalAcaoContatos
        ref="modal-acao-contatos"
        @salvar="salvarContatos"
        :tipoAcao="tipoAcaoModalContatos"
        v-model="mostrarModalContatos"
      />
      <ModalClassficacaoJustificativa
        ref="modal-classific-justific"
        @salvar-modal-classific="salvarAlteracaoClassificacao"
        v-model="mostrarModalClassificJustif"
      />
      <MenuObservacao
        :quantidadeObservacoes="quantidadeObservacoes"
        v-model="mostrarMenuObservacao"
      />
      <ModalConfirmarEdicao
        v-model="mostrarModalEdicao"
        @botao-confirmar="$store.commit()"
      />
      <ModalHistoricoContato
        ref="modal-historicos"
        v-model="mostrarModalHistoricos"
      />
      <ModalHistoricoClassificacao
        ref="modal-historicos-classific"
        v-model="mostrarModalHistoricoClassific"
      />
    </div>
  </layout-breadcrumb-cartao>
</template>

<script>
/* eslint-disable */

// mixins
import AdministracaoDetalheMixin from "./shared/AdministracaoDetalheMixin";

// componentes
// DETALHES
import CartaoInformacoes from "./shared/componentes/CartaoInformacoes";
import CartaoData from "./shared/componentes/CartaoData";

//CLASSIFICAÇÃO - TIPO DE ATUAÇÃO
import TipoAtuacaoClassificacao from "./shared/componentes/TipoAtuacaoClassificacao";
import ModalClassficacaoJustificativa from "./shared/componentes/ModalClassificacaoJustificativa/ModalClassficacaoJustificativa.vue";
import ModalHistoricoClassificacao from "./shared/componentes/ModalHistoricoClassificacao/ModalHistoricoClassificacao";

// CONTATOS
import TabelaContatos from "./shared/componentes/TabelaContatos/TabelaContatos";
import TabelaContatosExcluidos from "./shared/componentes/TabelaContatosExcluidos/TabelaContatosExcluidos";
import ModalAcaoContatos from "./shared/componentes/ModalAcaoContatos/ModalAcaoContatos";
import ModalHistoricoContato from "./shared/componentes/ModalHistoricoContato/ModalHistoricoContato";

// ANALISTAS
import ModalAcaoAnalista from "./shared/componentes/ModalAcaoAnalista/ModalAcaoAnalista";

// OBSERVAÇÕES
import ModalConfirmarEdicao from "./shared/componentes/Observacoes/ModalConfirmarEdicao";
import MenuObservacao from "./shared/componentes/Observacoes/MenuObservacao";

import { EnumPerfis } from "../../shared/helpers/Enum";

export default {
  mixins: [AdministracaoDetalheMixin],
  components: {
    CartaoInformacoes,
    TabelaContatos,
    TabelaContatosExcluidos,
    CartaoData,
    TipoAtuacaoClassificacao,
    ModalAcaoAnalista,
    ModalHistoricoContato,
    ModalAcaoContatos,
    MenuObservacao,
    ModalConfirmarEdicao,
    ModalClassficacaoJustificativa,
    ModalHistoricoClassificacao
  },
  data() {
    return {
      arrTexto: [],
      bread: [
        { titulo: "Início", url: "/home" },
        { titulo: "Administração", url: "/administracao" },
        { titulo: "Administração de Unimeds", url: "/administracao/unimeds" },
        { titulo: "Gerenciar Unimed" }
      ]
    };
  },
  computed: {
    mostrarCartaoData() {
      return this.papelUsuarioMixin.chave === EnumPerfis.GTR;
    },mostrarClassificacao() {
      return this.papelUsuarioMixin.chave === EnumPerfis.ADMINISTRADOR || this.papelUsuarioMixin.chave === EnumPerfis.GTR
    }

  }
};
</script>
